import React, { useCallback, forwardRef } from 'react'

import { KEY_VALUES } from '../../constants'
import { COLORS, THEME } from '../../styles'

import Styled from './Button.styled'

/**
 * @deprecated styles aren't up-to-date, prefer using styled(button|a) or Link
 */
const Button = forwardRef(
  (
    {
      children,
      className,
      disabled,
      href,
      isLoading,
      onClick,
      rel,
      size,
      style,
      target,
      to,
      type,
    },
    ref,
  ) => {
    const handleClick = useCallback(
      (event) => {
        if (disabled) {
          event.preventDefault()
        } else if (onClick) {
          onClick(event)
        }
      },
      [disabled, onClick],
    )
    const handleKeyPress = useCallback(
      (event) => {
        if (disabled) {
          event.preventDefault()
        } else if (onClick && event.key === KEY_VALUES.ENTER) {
          onClick(event)
        }
      },
      [disabled, onClick],
    )

    if (to) {
      return (
        <Styled.navLink
          className={className}
          style={style}
          to={to}
          disabled={disabled}
          onClick={handleClick}
          onKeyPress={handleKeyPress}
          size={size}
          ref={ref}
        >
          {children}
          {isLoading ? (
            <Styled.loader
              width={25}
              fill={disabled ? THEME.COLORS.foreground.secondary : COLORS.white}
            />
          ) : null}
        </Styled.navLink>
      )
    }

    if (href) {
      return (
        <Styled.externalLink
          ref={ref}
          className={className}
          style={style}
          href={href}
          disabled={disabled}
          onClick={handleClick}
          onKeyPress={handleKeyPress}
          target={target}
          rel={rel}
          size={size}
        >
          {children}
          {isLoading ? (
            <Styled.loader
              width={25}
              fill={disabled ? THEME.COLORS.foreground.secondary : COLORS.white}
            />
          ) : null}
        </Styled.externalLink>
      )
    }

    return (
      <Styled.button
        ref={ref}
        style={style}
        className={className}
        disabled={disabled}
        onClick={handleClick}
        onKeyPress={handleKeyPress}
        isLoading={isLoading}
        type={type}
        size={size}
      >
        {children}
        {isLoading ? (
          <Styled.loader
            width={25}
            fill={disabled ? THEME.COLORS.foreground.secondary : COLORS.white}
          />
        ) : null}
      </Styled.button>
    )
  },
)

Button.displayName = 'Button'

Button.defaultProps = {
  onClick: () => {},
}

export default Button
